export default '/build/fdc002d2.svg'